var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsChat2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.24 4.33002H5.76002C3.97002 4.33002 2.52002 5.86002 2.52002 7.75002V20.74C2.52002 22.63 3.97002 24.16 5.76002 24.16H19.94L22.95 27.33C23.27 27.67 23.77 27.77 24.19 27.59C24.62 27.4 24.9 26.96 24.9 26.47V24.16H26.25C28.04 24.16 29.49 22.63 29.49 20.74V7.75002C29.48 5.86002 28.03 4.33002 26.24 4.33002ZM28.5 20.73C28.5 22.04 27.49 23.1 26.24 23.1H24.4C24.13 23.1 23.91 23.33 23.91 23.62V26.4L23.95 26.43V26.77L23.64 26.57L20.49 23.25C20.4 23.15 20.27 23.1 20.15 23.1H5.76002C4.51002 23.1 3.50002 22.04 3.50002 20.73V7.75002C3.50002 6.44002 4.51002 5.38002 5.76002 5.38002H26.24C27.49 5.38002 28.5 6.44002 28.5 7.75002V20.73Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsChat2023);
export default __webpack_public_path__ + "static/media/beemg-icons-chat-2023.71960001a9a2c940387d2ae0ba7e0d5d.svg";
export { ForwardRef as ReactComponent };